v<template>
    <div>
        <el-row class="mb-10">
            <el-col :span="24" class="d-flex justify-content-end">
                    <el-tooltip class="item" effect="dark" content="Add Your Unavailability" placement="top">
                        <el-button type="primary" icon="el-icon-plus" @click="unavailabilityDialog = true"> Add Unavailability</el-button>
                    </el-tooltip>
            </el-col>
        </el-row>

        <el-row class="mb-20">
            <el-col :span="24">
              <h3>Fixed Unavailability</h3>
              <!-- el-table created from unavailableTable showing unavailable from and to and type-->
              <el-table
                :data="unavailableTable"
                border
                stripe
                style="width: 100%"
                class="item-table hidden-sm-and-down"
                :key="key"
              >
                <el-table-column label="Name" width="auto">
                <template slot-scope="scope">
                  <span>{{ scope.row.firstName }} {{ scope.row.lastName }}</span>
                </template>
                </el-table-column>
                <el-table-column label="Board" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.board.name }}</span>
                </template>
                </el-table-column>
                <el-table-column label="From" width=250>
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="scope.row.unavailable.unavailableFrom"
                    type="datetime"
                    value-format="timestamp"
                    format="MM/dd/yyyy hh:mm A"
                    placeholder="Unavailable From"
                    :picker-options="pickerOptions"
                    style="width: 100%"
                    :disabled="!editingFixedRows[scope.$index]"
                    >
                    </el-date-picker>
                </template>
                </el-table-column>
                <el-table-column label="To" width="250">
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="scope.row.unavailable.unavailableTo"
                    type="datetime"
                    value-format="timestamp"
                    format="MM/dd/yyyy hh:mm A"
                    placeholder="Unavailable To"
                    :picker-options="pickerOptions"
                    style="width: 100%"
                    :disabled="!editingFixedRows[scope.$index]"
                    >
                    </el-date-picker>
                </template>
                </el-table-column>
                <el-table-column label="" width="90">
                <template slot-scope="scope">
                  <span>
                    <el-tooltip class="item" effect="dark"  placement="top">
                        <div slot="content">{{editingFixedRows[scope.$index] ? 'Save' : 'Edit'}}</div>
                        <el-button type="text" @click="editUnavailability(scope.$index, 'fixed')">
                          <i class="el-icon-edit" v-if="!editingFixedRows[scope.$index]"></i>
                          <i class="el-icon-check" v-else></i>
                        </el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Delete" placement="top">
                      <el-button type="text" icon="el-icon-delete" @click="deleteUnavailability(scope.$index, 'fixed')"></el-button>
                    </el-tooltip>
                  </span>
                </template>
                </el-table-column>
              </el-table>
              <el-table
                :data="unavailableTable"
                border
                stripe
                style="width: 100%"
                class="item-table hidden-md-and-up"
                :key="key"
              >
                <el-table-column label="Name" width="120">
                <template slot-scope="scope">
                  <span>{{ scope.row.firstName }} {{ scope.row.lastName }}</span>
                </template>
                </el-table-column>
                <el-table-column label="Board" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.board.name }}</span>
                </template>
                </el-table-column>
                <el-table-column label="From" width=250>
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="scope.row.unavailable.unavailableFrom"
                    type="datetime"
                    value-format="timestamp"
                    format="MM/dd/yyyy hh:mm "
                    placeholder="Unavailable From"
                    :picker-options="pickerOptions"
                    style="width: 100%"
                    :disabled="!editingFixedRows[scope.$index]"
                    >
                    </el-date-picker>
                </template>
                </el-table-column>
                <el-table-column label="To" width="250">
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="scope.row.unavailable.unavailableTo"
                    type="datetime"
                    value-format="timestamp"
                    format="MM/dd/yyyy hh:mm "
                    placeholder="Unavailable To"
                    :picker-options="pickerOptions"
                    style="width: 100%"
                    :disabled="!editingFixedRows[scope.$index]"
                    >
                    </el-date-picker>
                </template>
                </el-table-column>
                <el-table-column label="" width="95">
                <template slot-scope="scope">
                  <span>
                    <el-tooltip class="item" effect="dark"  placement="top">
                        <div slot="content">{{editingFixedRows[scope.$index] ? 'Save' : 'Edit'}}</div>
                        <el-button type="text" @click="editUnavailability(scope.$index, 'fixed')">
                          <i class="el-icon-edit" v-if="!editingFixedRows[scope.$index]"></i>
                          <i class="el-icon-check" v-else></i>
                        </el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Delete" placement="top">
                      <el-button type="text" icon="el-icon-delete" @click="deleteUnavailability(scope.$index, 'fixed')"></el-button>
                    </el-tooltip>
                  </span>
                </template>
                </el-table-column>
              </el-table>
      </el-col>
        </el-row>
        <el-row class="mb-20">
            <el-col :span="24">
              <h3>Recurring Unavailability</h3>
              <!-- el-table created from unavailableTable showing unavailable from and to and type-->
              <el-table
                :data="recurringUnavailableTable"
                border
                stripe
                style="width: 100%"
                class="item-table hidden-sm-and-down"
                :key="key"
              >
              <el-table-column
                  label="Name"
                  width="190"
                >
                <template slot-scope="scope">
                  <span class="break-word">
                    {{ scope.row.firstName }} {{ scope.row.lastName }}
                  </span>
                </template>
                </el-table-column>
                <el-table-column label="Board" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.board.name }}</span>
                </template>
                </el-table-column>
                <el-table-column
                  label="Start Date"
                  width=190
                >
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="scope.row.recurringUnavailable.unavailableFrom"
                    type="date"
                    placeholder="Unavailable From"
                    value-format="timestamp"
                    format="MM/dd/yyyy"
                    :picker-options="pickerOptions"
                    style="width: 100%"
                    :disabled="!editingRecurringRows[scope.$index]"
                    >
                    </el-date-picker>
                </template>
                </el-table-column>
                <el-table-column
                  label="End Date"
                  width="190"
                >
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="scope.row.recurringUnavailable.unavailableTo"
                    type="date"
                    placeholder="Unavailable To"
                    value-format="timestamp"
                    format="MM/dd/yyyy"
                    :picker-options="pickerOptions"
                    style="width: 100%"
                    :disabled="!editingRecurringRows[scope.$index]"
                    >
                    </el-date-picker>
                </template>
                </el-table-column>
                <el-table-column
                  label="Start Time"
                  width=170
                >
                <template slot-scope="scope">
                  <el-time-picker
                    v-model="scope.row.recurringUnavailable.timeFrom"
                    type="time"
                    placeholder="Time From"
                    value-format="HH:mm:ss"
                    format="hh:mm A"
                    :picker-options="pickerOptions"
                    style="width: 100%"
                    :disabled="!editingRecurringRows[scope.$index]"
                  ></el-time-picker>
                </template>
                </el-table-column>
                <el-table-column
                  label="End Time"
                  width="170"
                >
                <template slot-scope="scope">
                  <el-time-picker
                    v-model="scope.row.recurringUnavailable.timeTo"
                    type="time"
                    placeholder="Time From"
                    value-format="HH:mm:ss"
                    format="hh:mm A"
                    :picker-options="pickerOptions"
                    style="width: 100%"
                    :disabled="!editingRecurringRows[scope.$index]"
                  ></el-time-picker>
                </template>
                </el-table-column>
                <el-table-column
                  prop="recurringUnavailable.dayOfWeek"
                  label="Unavailable On"
                  width="150"
                  :formatter="(r,c,v)=> joinDay(v)"
                  >
                    <template slot-scope="scope">
                      <span v-if="!editingRecurringRows[scope.$index]">
                        <span class="break-word" v-for="(day, index) in scope.row.recurringUnavailable.dayOfWeek" :key="index">
                          <el-tag
                            v-if="day"
                            :key="index"
                            type="info"
                            size="small"
                            style="margin: 3px;"
                            >{{ day }}</el-tag>
                        </span>

                      </span>
                    <el-select
                      v-if="editingRecurringRows[scope.$index]"
                      v-model="scope.row.recurringUnavailable.dayOfWeek"
                      multiple
                      placeholder="Unavailable On"
                      style="width: 100%"
                      :disabled="!editingRecurringRows[scope.$index]"
                      >
                      <el-option
                        v-for="day in dayOfWeek"
                        :key="day"
                        :label="day"
                        :value="day"
                        >
                      </el-option>
                    </el-select>
                </template>
                </el-table-column>
                <el-table-column
                  label=""
                  width="90"
                  fixed="right"
                >
                <template slot-scope="scope">
                  <span>
                    <el-tooltip class="item" effect="dark" content="Edit" placement="top">
                      <el-button type="text" @click="editUnavailability(scope.$index, 'recurring')">
                        <i class="el-icon-edit" v-if="!editingRecurringRows[scope.$index]"></i>
                        <i class="el-icon-check" v-else></i>
                      </el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Delete" placement="top">
                      <el-button type="text" icon="el-icon-delete" @click="deleteUnavailability(scope.$index, 'recurring')"></el-button>
                    </el-tooltip>
                  </span>
                </template>
                </el-table-column>

              </el-table>
              <el-table
                :data="recurringUnavailableTable"
                border
                stripe
                style="width: 100%"
                class="item-table hidden-md-and-up"
                :key="key"
              >
              <el-table-column
                  label="Name"
                  width="120"
                >
                <template slot-scope="scope">
                  <span class="break-word">
                    {{ scope.row.firstName }} {{ scope.row.lastName }}
                  </span>
                </template>
                </el-table-column>
                <el-table-column label="Board" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.board.name }}</span>
                </template>
                </el-table-column>
                <el-table-column
                  label="Start Date"
                  width=190
                >
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="scope.row.recurringUnavailable.unavailableFrom"
                    type="date"
                    placeholder="Unavailable From"
                    value-format="timestamp"
                    format="MM/dd/yyyy"
                    :picker-options="pickerOptions"
                    style="width: 100%"
                    :disabled="!editingRecurringRows[scope.$index]"
                    >
                    </el-date-picker>
                </template>
                </el-table-column>
                <el-table-column
                  label="End Date"
                  width="190"
                >
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="scope.row.recurringUnavailable.unavailableTo"
                    type="date"
                    placeholder="Unavailable To"
                    value-format="timestamp"
                    format="MM/dd/yyyy"
                    :picker-options="pickerOptions"
                    style="width: 100%"
                    :disabled="!editingRecurringRows[scope.$index]"
                    >
                    </el-date-picker>
                </template>
                </el-table-column>
                <el-table-column
                  label="Start Time"
                  width=170
                >
                <template slot-scope="scope">
                  <el-time-picker
                    v-model="scope.row.recurringUnavailable.timeFrom"
                    type="time"
                    placeholder="Time From"
                    value-format="HH:mm"
                    format="hh:mm A"
                    :picker-options="pickerOptions"
                    style="width: 100%"
                    :disabled="!editingRecurringRows[scope.$index]"
                  ></el-time-picker>
                </template>
                </el-table-column>
                <el-table-column
                  label="End Time"
                  width="170"
                >
                <template slot-scope="scope">
                  <el-time-picker
                    v-model="scope.row.recurringUnavailable.timeTo"
                    type="time"
                    placeholder="Time From"
                    value-format="HH:mm"
                    format="hh:mm A"
                    :picker-options="pickerOptions"
                    style="width: 100%"
                    :disabled="!editingRecurringRows[scope.$index]"
                  ></el-time-picker>
                </template>
                </el-table-column>
                <el-table-column
                  prop="recurringUnavailable.dayOfWeek"
                  label="Unavailable On"
                  width="160"
                  :formatter="(r,c,v)=> joinDay(v)"
                  >
                    <template slot-scope="scope">
                      <span v-if="!editingRecurringRows[scope.$index]">
                        <span class="break-word" v-for="(day, index) in scope.row.recurringUnavailable.dayOfWeek" :key="index">
                          <el-tag
                            v-if="day"
                            :key="index"
                            type="info"
                            size="small"
                            style="margin: 3px;"
                            >{{ day }}</el-tag>
                        </span>

                      </span>
                    <el-select
                      v-if="editingRecurringRows[scope.$index]"
                      v-model="scope.row.recurringUnavailable.dayOfWeek"
                      multiple
                      placeholder="Unavailable On"
                      style="width: 100%"
                      :disabled="!editingRecurringRows[scope.$index]"
                      >
                      <el-option
                        v-for="day in dayOfWeek"
                        :key="day"
                        :label="day"
                        :value="day"
                        >
                      </el-option>
                    </el-select>
                </template>
                </el-table-column>
                <el-table-column
                  label=""
                  width="100"
                  fixed="right"
                >
                <template slot-scope="scope">
                  <span>
                    <el-tooltip class="item" effect="dark" content="Edit" placement="top">
                      <el-button type="text" @click="editUnavailability(scope.$index, 'recurring')">
                        <i class="el-icon-edit" v-if="!editingRecurringRows[scope.$index]"></i>
                        <i class="el-icon-check" v-else></i>
                      </el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Delete" placement="top">
                      <el-button type="text" icon="el-icon-delete" @click="deleteUnavailability(scope.$index, 'recurring')"></el-button>
                    </el-tooltip>
                  </span>
                </template>
                </el-table-column>

              </el-table>

      </el-col>
        </el-row>

    <el-dialog :visible.sync="unavailabilityDialog">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px">
        <el-form-item label="Referee" prop="referee">
          <el-select v-model="form.refereeId" placeholder="Please select a referee" @change="findRelatedBoards">
            <el-option
              v-for="item in referees"
              :key="item._id"
              :value="item._id"
              :label="`${item.profile.firstName} ${item.profile.lastName}`"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.refereeId" label="Board" prop="board">
          <el-select v-model="form.board" placeholder="Please select a board">
            <el-option
              v-for="item in appointmentBoards"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Unavailable Type" prop="unavailableType">
          <el-select v-model="form.unavailableType" placeholder="Unavailable Type">
            <el-option
              v-for="item in unavailableType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Unavailable From" prop="unavailableFrom">
          <el-date-picker
             v-if="form.unavailableType === 'recurring'"
            v-model="form.unavailableFrom"
            type="date"
            placeholder="Unavailable From"
            value-format="timestamp"
            format="MM/dd/yyyy"
            :picker-options="pickerOptions"
            style="width: 100%"></el-date-picker>
          <el-date-picker
            v-if="form.unavailableType === 'fixed'"
            v-model="form.unavailableFrom"
            type="datetime"
            value-format="timestamp"
            format="MM/dd/yyyy hh:mm A"
            placeholder="Unavailable From"
            :picker-options="pickerOptions"
            style="width: 100%"
            >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="Unavailable To" prop="unavailableTo">
          <el-date-picker
             v-if="form.unavailableType === 'recurring'"
            v-model="form.unavailableTo"
            type="date"
            placeholder="Unavailable To"
            value-format="timestamp"
            format="MM/dd/yyyy"
            :picker-options="pickerOptions"
            style="width: 100%"

          ></el-date-picker>
          <el-date-picker
            v-if="form.unavailableType === 'fixed'"
            v-model="form.unavailableTo"
            type="datetime"
            value-format="timestamp"
            format="MM/dd/yyyy hh:mm A"
            placeholder="Unavailable To"
            :picker-options="pickerOptions"
            style="width: 100%"
            >
          </el-date-picker>
        </el-form-item>
        <div v-if="form.unavailableType === 'recurring'">
          <el-form-item label="Day of Week" prop="dayOfWeek">
            <!-- in checkbox format allow multiple choice -->
            <el-checkbox-group v-model="form.dayOfWeek">
              <el-checkbox-button v-for="item in dayOfWeek" :key="item" :label="item" >
                {{ item }}
              </el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="Time From" prop="timeFrom">
            <!-- value as timestamp -->
            <el-time-picker
              v-model="form.timeFrom"
              type="time"
              placeholder="Time From"
              value-format="HH:mm:ss"
              format="hh:mm A"
              :picker-options="pickerOptions"
              style="width: 100%"
            ></el-time-picker>
          </el-form-item>
          <el-form-item label="Time To" prop="timeTo">
            <!-- value as timestamp -->
            <el-time-picker
              v-model="form.timeTo"
              type="time"
              placeholder="Time To"
              value-format="HH:mm:ss"
              format="hh:mm A"
              :picker-options="pickerOptions"
              style="width: 100%"
            ></el-time-picker>
          </el-form-item>
        </div>
        <el-form-item label="Reason" prop="reason">
          <el-input v-model="form.reason" placeholder="Reason"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="unavailabilityDialog = false">Cancel</el-button>
        <el-button type="primary" @click="handleSubmit">Submit</el-button>
      </div>
    </el-dialog>
    </div>
</template>

<script>
import _ from 'lodash';
import { errormsg } from '../../../utils/constants';

const defaultRequiredRule = { required: true, trigger: 'blur', message: errormsg.required };
const initForm = () => _.cloneDeep({
  refereeId: undefined,
  board: undefined,
  unavailableFrom: undefined,
  unavailableTo: undefined,
  unavailableType: 'fixed',
  dayOfWeek: [],
  timeFrom: undefined,
  timeTo: undefined,
  reason: ''
});

const isDateRangeValid = (form, self) => {
  if (form.unavailableFrom > form.unavailableTo) {
    self.$message({
      message: 'Unavailable From must be before Unavailable To',
      type: 'error'
    });
    return false;
  }
  return true;
};

const isTimeRangeValid = (form, self) => {
  if (form.timeFrom && form.timeTo && (form.timeFrom > form.timeTo)) {
    self.$message({
      message: 'Time From must be before Time To',
      type: 'error'
    });
    return false;
  }
  return true;
};
export default {
  name: 'RefereeAppointedTable',
  props: {
    referees: {
      type: Array,
      required: true
    },
    unavailabilities: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      editingFixedRows: [],
      editingRecurringRows: [],
      unavailableTable: [],
      recurringUnavailableTable: [],
      appointmentBoards: [],
      key: 0,
      status: [{
        value: 'confirmed',
        label: 'Confirm'
      }, {
        value: 'declined',
        label: 'Decline'
      }],
      unavailableType: [{
        value: 'recurring',
        label: 'Recurring'
      }, {
        value: 'fixed',
        label: 'Fixed'
      }],
      dayOfWeek: [
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat',
        'Sun'
      ],
      pickerOptions: {
        shortcuts: [{
          text: 'Today',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: 'Tomorrow',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: 'A week later',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: 'A month later',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
            picker.$emit('pick', date);
          }
        }]
      },
      form: initForm(),
      rules: {
        refereeId: defaultRequiredRule,
        board: defaultRequiredRule,
        unavailableFrom: defaultRequiredRule,
        unavailableTo: defaultRequiredRule,
        unavailableType: defaultRequiredRule,
        // dayOfWeek, TimeFrom, TimeTo required if unavailableType is recurring
        dayOfWeek: {
          required: false,
          trigger: 'blur',
          message: errormsg.required
        },
        timeFrom: {
          required: true,
          trigger: 'blur',
          message: errormsg.required
        },
        timeTo: {
          required: true,
          trigger: 'blur',
          message: errormsg.required
        },
      },
      unavailabilityDialog: false,
    };
  },
  mounted() {
    this.unavailabilities.forEach((unavailability) => {
      if (unavailability.unavailable) {
        this.unavailableTable.push({
          ...unavailability,
        });
      }
      if (unavailability.recurringUnavailable) {
        this.recurringUnavailableTable.push({
          ...unavailability,
        });
      }
    });
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!isDateRangeValid(this.form, this)) {
            return;
          }
          if (!isTimeRangeValid(this.form, this)) {
            return;
          }
          if (this.form.unavailableType === 'recurring') {
            if (!this.form.timeFrom || !this.form.timeTo) {
              this.$message({
                message: 'Please select time from and time to',
                type: 'error'
              });
              return;
            }
          }
          this.unavailabilityDialog = false;

          const referee = this.referees.find((ref) => ref._id === this.form.refereeId);
          const board = this.appointmentBoards.find((bd) => bd._id === this.form.board);
          if (this.form.unavailableType === 'recurring') {
            this.recurringUnavailableTable.push({
              _id: this.form.refereeId,
              firstName: referee.profile.firstName,
              lastName: referee.profile.lastName,
              board: {
                _id: board._id,
                name: board.name
              },
              recurringUnavailable: {
                unavailableFrom: this.form.unavailableFrom,
                unavailableTo: this.form.unavailableTo,
                dayOfWeek: this.form.dayOfWeek,
                timeFrom: this.form.timeFrom,
                timeTo: this.form.timeTo,
                reason: this.form.reason
              }
            });
          } else {
            this.unavailableTable.push({
              _id: this.form.refereeId,
              firstName: referee.profile.firstName,
              lastName: referee.profile.lastName,
              board: {
                _id: board._id,
                name: board.name
              },
              unavailable: {
                unavailableFrom: this.form.unavailableFrom,
                unavailableTo: this.form.unavailableTo,
                timeFrom: this.form.timeFrom,
                timeTo: this.form.timeTo,
                reason: this.form.reason

              }

            });
          }
          this.$emit('add-unavailability', this.form);
        }
        this.key++;
      });
      return true;
    },
    editUnavailability(rowIndex, type) {
      if ((this.editingFixedRows[rowIndex] && type === 'fixed') || (this.editingRecurringRows[rowIndex] && type === 'recurring')) {
        if (type === 'recurring') {
          const updateObj = this.recurringUnavailableTable[rowIndex];
          if (!isDateRangeValid(updateObj.recurringUnavailable, this)) {
            return;
          }
          if (!isTimeRangeValid(updateObj.recurringUnavailable, this)) {
            return;
          }
          this.$emit('update-unavailability', updateObj);
          this.$set(this.editingRecurringRows, rowIndex, false);
          this.editingRecurringRows = [];
        } else {
          const updateObj = this.unavailableTable[rowIndex];
          if (!isDateRangeValid(updateObj.unavailable, this)) {
            return;
          }
          this.$emit('update-unavailability', updateObj);
          this.$set(this.editingFixedRows, rowIndex, false);
          this.editingFixedRows = [];
        }
      } else if (type === 'fixed') {
        this.setEditingRow(this.editingFixedRows, rowIndex);
      } else {
        this.setEditingRow(this.editingRecurringRows, rowIndex);
      }
    },
    deleteUnavailability(rowIndex, type) {
      this.$confirm('Are you sure you want to delete this unavailability?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(() => {
        if (type === 'fixed') {
          this.$emit('delete-unavailability', this.unavailableTable[rowIndex]);
          this.unavailableTable.splice(rowIndex, 1);
        } else {
          this.$emit('delete-unavailability', this.recurringUnavailableTable[rowIndex]);
          this.recurringUnavailableTable.splice(rowIndex, 1);
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete cancelled'
        });
      });
    },
    findRelatedBoards(refereeId) {
      const relatedBoards = this.referees.find((referee) => referee._id === refereeId);

      if (relatedBoards && relatedBoards.boards.length) {
        this.appointmentBoards = relatedBoards.boards;
      }
    },
    joinDay(dayOfWeek) {
      if (!dayOfWeek.length) {
        return 'Everyday';
      }
      return dayOfWeek.join(', ');
    },
    setEditingRow(target, index) {
      this.$set(target, index, true);
      _.forEach(target, (v, k) => {
        if (k !== index) {
          this.$set(target, k, false);
        }
      });
    }

  },
  watch: {
    // eslint-disable-next-line func-names
    'form.refereeId': function (newVal) {
      this.findRelatedBoards(newVal);
    }
  }

};
</script>

<style lang="scss" scoped>
::v-deep .item-table {
  border: 1px solid rgba(45, 58, 69, 0.1);
  text-align: center;

  th {
    background: #f6f8fa !important;
    padding-left: 1em;
    padding-right: 1em;
  }

  td {
    background-color: white !important;
    padding: 2em 1em;
  }
}

</style>
